import { useMutation } from '@apollo/client';
import { SAVE_PRODUCT_REFUND_POLICY } from '..';

export function useMutationSaveProductRefundPolicy() {
  const [saveProductRefundPolicy] = useMutation(SAVE_PRODUCT_REFUND_POLICY);

  const handleSaveProductRefundPolicy = async (
    id: string,
    refundPolicyId: string,
  ) => {
    try {
      await saveProductRefundPolicy({
        variables: {
          id,
          param: {
            refundPolicyId,
          },
        },
      });
    } catch (error) {
      let message = 'Unknown Error';
      if (error instanceof Error) message = error.message;

      (window as any).showToast(message, 3000);
    }
  };

  return { handleSaveProductRefundPolicy };
}
